import emojiAliases from './emojiAliases'

const aliasesRegex = /:([\w\-_+]+):/g

function emojify(text) {
  return text.replace(aliasesRegex, (str, val) => {
    if (emojiAliases[val]) return emojiAliases[val]
    return str
  })
}

export default emojify
